import {UseCase} from "@livechat/shared";
import {AnswerTemplateAggregate} from "../aggregates";
import {AnswerTemplateGateway} from "../repositories";
import {Observable} from "rxjs";

export class DeleteAnswerTemplateUseCase implements UseCase<number, Observable<null>> {

  constructor(private answerTemplateRepo: AnswerTemplateGateway) {
  }

  execute(answerTemplateId: number): Observable<null> {
    return this.answerTemplateRepo.delete(answerTemplateId);
  }
}
